export const CONTACT_US_EMAIL_TYPES = {
  CHANGE_ACCOUNT_INFO_REQUEST: 'changeAccountInfoRequest',
  DELETE_ACCOUNT_REQUEST: 'deleteAccountRequest',
  TURN_OFF_TWOFA_REQUEST: 'turnoffTwofaRequest',
  VERIFICATION_FOR_CORPORATE: 'verificationForCorporate',
  DEFAULT_REQUEST: 'defaultRequest',
} as const;

export type ContactUsEmailType =
  (typeof CONTACT_US_EMAIL_TYPES)[keyof typeof CONTACT_US_EMAIL_TYPES];

export type ContactUsActionRequest = {
  body: string;
  email: string;
  subject: string;
};

export type ContactUsDictionary = {
  email: string;
  emailforlogs: string;
  subject: string;
  subjectforlogs: string;
  body: string;
  bodyforlogs: string;
  [CONTACT_US_EMAIL_TYPES.CHANGE_ACCOUNT_INFO_REQUEST]: ContactUsActionRequest;
  [CONTACT_US_EMAIL_TYPES.DELETE_ACCOUNT_REQUEST]: ContactUsActionRequest;
  [CONTACT_US_EMAIL_TYPES.TURN_OFF_TWOFA_REQUEST]: ContactUsActionRequest;
  [CONTACT_US_EMAIL_TYPES.VERIFICATION_FOR_CORPORATE]: ContactUsActionRequest;
};
